var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    [
      _vm._l(_vm.standardCardProps, function (card) {
        return _c(
          "v-col",
          { key: card.title, attrs: { cols: "12", sm: "6", md: "3" } },
          [
            _c(
              "v-card",
              {
                attrs: { height: "100%", color: _vm.getCardColor(card) },
                on: {
                  click: function ($event) {
                    return _vm.toggleFilter(card.title)
                  },
                },
              },
              [
                _c(
                  "v-card-title",
                  [
                    _c("v-icon", { attrs: { large: "", left: "" } }, [
                      _vm._v("mdi-" + _vm._s(card.icon)),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: { "data-cy": "cardText" },
                      },
                      [_vm._v(_vm._s(card.title + ": " + card.number))]
                    ),
                  ],
                  1
                ),
                _c("v-card-text", [_vm._v(_vm._s(card.subtitle))]),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm.profileErrorProps.number &&
      _vm.currentStatusFilter.indexOf("Waived") == -1
        ? _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "d-flex flex-no-wrap justify-space-between",
                  attrs: {
                    color: _vm.profileErrorProps.color,
                    elevation: "12",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "v-icon",
                            { staticClass: "pr-3", attrs: { large: "" } },
                            [
                              _vm._v(
                                "mdi-" + _vm._s(_vm.profileErrorProps.icon)
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                `ALERT: ${_vm.profileErrorProps.number} ${_vm.profileErrorProps.title}s`
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("v-card-text", [
                        _vm._v(_vm._s(_vm.profileErrorProps.subtitle)),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled:
                              _vm.filter.status.indexOf("Profile Error") !== -1,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("show-errors")
                            },
                          },
                        },
                        [_vm._v(" Filter to Errors ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.waivedProfiles.number &&
      _vm.currentStatusFilter.indexOf("Profile Error") == -1
        ? _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "d-flex flex-no-wrap justify-space-between",
                  attrs: { color: _vm.waivedProfiles.color, elevation: "12" },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "v-icon",
                            { staticClass: "pr-3", attrs: { large: "" } },
                            [_vm._v("mdi-" + _vm._s(_vm.waivedProfiles.icon))]
                          ),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                `INFO: ${_vm.waivedProfiles.number} ${_vm.waivedProfiles.title} Tests`
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("v-card-text", [
                        _vm._v(_vm._s(_vm.waivedProfiles.subtitle)),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled:
                              _vm.filter.status.indexOf("Waived") !== -1,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("show-waived")
                            },
                          },
                        },
                        [_vm._v(" Filter to Waived ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }